import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import { withTranslation } from 'react-i18next';
import HeaderPortal from '../layout/HeaderPortal';
import { useTitle } from 'utils/hooks/useTitle';

const NotFound = ({ title, t }) => {
  useTitle(t(title));
  return (
    <Card>
      <HeaderPortal>
        <>{t(title)}</>
      </HeaderPortal>
    </Card>
  );
};

NotFound.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string
};

export default withTranslation()(NotFound);
